document.addEventListener('DOMContentLoaded', () => {
    const sessionStorageKey = 'shopify_localization_called';
    const eventListeners = ['click', 'keypress'];
    const modalElement = document.getElementById(window.localizationId === undefined ? '' : window.localizationId);
    let localizationForms = modalElement?.querySelectorAll('.shopify-localization-form');
    const localizationConfirmBtn = modalElement?.querySelector('[data-localization-confirm]');
    const localizeData = {
        country: '',
        locale: '',
        ...window.localizationOptions
    };

    // Open modal on button click
    document.querySelectorAll('.localization-selector__button').forEach(button => {
        eventListeners.forEach(event => {
            button.addEventListener(event, (e) => {
                e.stopPropagation();
                e.stopImmediatePropagation();
                e.preventDefault();
                if (!modalElement) return;

                // Open the modal
                if (typeof modalElement.open === 'function') {
                    modalElement.open(button);

                    if (window.requestIdleCallback) {    
                        modalElement.classList.add('localization-selector--loading');
                        requestIdleCallback(async () => {
                            setTimeout(() => {
                                modalElement.classList.remove('localization-selector--loading');
                            }, 750);

                            for (const form of localizationForms) {
                                const buttons = form.querySelectorAll(`button[name="country_code"]`);
                                const selectedBtn = form.querySelector(`button[name="country_code"][aria-selected="true"]`);

                                // Fetch all non-selected countries sequentially to avoid parallel requests
                                for (const btn of [...buttons].filter(btn => btn !== selectedBtn && !window.sessionStorage.getItem(`${sessionStorageKey}-${btn.value}`))) {
                                    await formSubmit(form, btn.value, false);
                                }

                                // Fetch selected country last — updates the DOM
                                if (selectedBtn && !window.sessionStorage.getItem(`${sessionStorageKey}-${selectedBtn.value}`)) {
                                    await formSubmit(form, selectedBtn.value, false);
                                }
                                modalElement.classList.remove('localization-selector--loading');
                            }
                            const selectedBtn = form.querySelector(`button[name="country_code"][aria-selected="true"]`);
                            if (selectedBtn && !window.sessionStorage.getItem(`${sessionStorageKey}-${selectedBtn.value}`)) {
                                await formSubmit(form, selectedBtn.value, false);
                            }
                        }, { timeout: 1000 });
                    }
                }
            });
        });
    });

    // Reset and set events for localization forms
    const resetFormsEvents = (forms) => {
        forms?.forEach((form) => {
            // Disable default submission
            form.addEventListener('submit', (e) => {
                e.preventDefault();
            });

            form.querySelectorAll('[role="option"]').forEach((optionButton) => {
                eventListeners.forEach(event => {
                    optionButton.addEventListener(event, (e) => {
                        localizationConfirmBtn.disabled = true;
                        const target = e.target.closest('button');
                        if (!target) return;
                        e.preventDefault();
                        form.querySelectorAll(`button[name="${target.name}"]`)
                            .forEach((b) => b.setAttribute('aria-selected', 'false'));
                        form?.parentElement?.parentElement?.close()
                        target.setAttribute('aria-selected', 'true');

                        if (target.name?.indexOf('country_code') > -1) {
                            localizeData.country = target.value;
                            countryFormEvent(e, form);
                            return;
                        }

                        if (target.name?.indexOf('locale_code') > -1) {
                            localizeData.locale = target.value;
                            localizationConfirmBtn.disabled = false;
                            document.querySelectorAll('.accordion__button[aria-controls*="-country"]').forEach((btn) => {
                                btn.textContent = target.textContent;
                            });
                            return;
                        }
                    });
                });
            });
        });
    }

    const updateLists = (accordionList, localizationForms, countryCode, update = true) => {
        if (!update && accordionList) {
            const html = [...accordionList].reduce((acc, curr) => acc + curr.outerHTML, '');
            window.sessionStorage.setItem(`${sessionStorageKey}-${countryCode}`, html);

            return;
        }
        accordionList?.forEach((updatedAccordion) => {
            localizationForms.forEach((form) => {
                const accordion = form.parentElement.parentElement;
                const accordionForm = updatedAccordion.querySelector('form');

                if (form.id === accordionForm.id && accordion) {
                    const accordionContent = updatedAccordion.querySelector('.accordion__content');
                    const localeSelectedBtn = updatedAccordion.querySelector(`button[name="locale_code"][aria-selected="true"]`);

                    accordion.querySelector('.accordion__button').innerHTML = updatedAccordion.querySelector('.accordion__button').innerHTML;
                    accordion.querySelector('.accordion__content').innerHTML = accordionContent.innerHTML;

                    localizationForms = modalElement?.querySelectorAll('.shopify-localization-form');
                    resetFormsEvents(localizationForms);

                    if (localeSelectedBtn) {
                        localizeData.locale = localeSelectedBtn.value;
                        localizationConfirmBtn.disabled = false;
                    }
                }
            });
        });
    };

    const formSubmit = async (form, countryCode, update = true) => {
        const countryFormData = new FormData(form);
        countryFormData.set('country_code', countryCode);

        try {
            const response = await fetch(form.dataset.action || '/localization', {
                method: 'POST',
                body: countryFormData,
                credentials: 'same-origin',
                headers: {
                    Accept: 'text/html',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                redirect: 'follow',
            });

            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const updatedList = doc.querySelectorAll('accordion-select.localization-selector__accordion');

            updateLists(updatedList, localizationForms, countryCode, update);
            if (update) {
                localizationForms = modalElement?.querySelectorAll('.shopify-localization-form');
            }
        } catch (err) {
            console.error('Error fetching localization data:', err);
        }
    };

    const countryFormEvent = async (e, form) => {
        const clickedBtn = e.target.closest('button[name="country_code"]');
        if (!clickedBtn) return;
        localizeData.country = clickedBtn.value;

        const cachedContent = window.sessionStorage.getItem(`${sessionStorageKey}-${localizeData.country}`);

        if (cachedContent) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(cachedContent, 'text/html');
            const updatedList = doc.querySelectorAll('accordion-select.localization-selector__accordion');

            updateLists(updatedList, localizationForms);
            localizationForms = modalElement?.querySelectorAll('.shopify-localization-form');
            return;
        }

        await formSubmit(form, localizeData.country);
    }

    resetFormsEvents(localizationForms);

    eventListeners.forEach(event => {
        localizationConfirmBtn?.addEventListener(event, (e) => {
            e.preventDefault();
            if (!localizationForms ||
                localizationForms.length === 0
            ) {
                modalElement.close();
                return;
            }

            localizationConfirmBtn.disabled = true;

            if (localizationForms && localizationForms[localizationForms.length - 1]) {
                const formData = new FormData(localizationForms[localizationForms.length - 1]);

                if (localizeData.locale) {
                    formData.set('locale_code', localizeData.locale);
                }
                if (localizeData.country) {
                    formData.set('country_code', localizeData.country);
                }

                // Submit using fetch with FormData
                fetch(localizationForms[localizationForms.length - 1].action || '/localization', {
                    method: 'POST',
                    body: formData,
                    credentials: 'same-origin',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    }
                }).then((res) => {
                    window.location.href = res.url;
                }).catch(() => {
                    window.location.reload();
                });
                return;
            }

            window.location.reload();
        });
    });
});
